<template>
  <div class="pages">
    <div class="pageContent settingPage">
      <div class="setting-box">
        <div class="goBack" @click="$router.back()">
          <img src="@/assets/img/goBack_btn_black.svg" alt="" />
        </div>
        <div class="menu-box">
          <div class="menu-item" @click="$router.push('changePassword')">{{ $t3('修改密码', 'Change password') }}<img
              src="@/assets/img/arrow_right.svg" /></div>
        </div>
      </div>
      <div class="setting-btn" @click="logout">{{ $t3('退出登录', 'Log out') }}</div>
    </div>
  </div>
</template>
  
<script>

export default {
  name: 'setting',
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    logout() {
      this.$store.dispatch('user/logout').then(() => {
        this.$router.push('login')
      })
    }
  }
}
</script>
  
<style lang="scss" scoped>
.setting-box {
  background: #FFF;
}
</style>